import { HttpContextToken } from "@angular/common/http";
import { CreateDocType } from "@app/features/document-control/create-document-modal/create-document-modal.component";
import { DriveItem } from "@app/features/document-control/models/document.model";
import { DragCardItems } from "@app/features/document-control/models/emp-dashboard-viewes.modal";
import { ToasterOptions } from "@Mobilesentrix/ms-design-system";
import { environment } from "src/environments/environment";
import { assetUrl } from "@app/shared/utils/asset-url";
// import { any } from "../modules/chat/modals/mentions.modal";
// import { ChatRoom, any } from "../modules/chat/modals/msg-attachments.modal";
// import { any } from "../modules/chat/modals/socket-clint-io.modals";
// import { CONSOLE } from "./loggers.level";
// import { AttendanceType, DragCardItems, EmployeeDashBoardViewSectionSEnum } from "../interfaces/emp-dashboard-viewes.modal";
export const LOADING_ICON_D = 'M9.75,7.713H8.244V5.359c0-0.276-0.224-0.5-0.5-0.5H7.65c-0.276,0-0.5,0.224-0.5,0.5v2.947 c0,0.276,0.224,0.5,0.5,0.5h0.094c0.001,0,0.002-0.001,0.003-0.001S7.749,8.807,7.75,8.807h2c0.276,0,0.5-0.224,0.5-0.5V8.213 C10.25,7.937,10.026,7.713,9.75,7.713z M9.75,2.45h-3.5c-1.82,0-3.3,1.48-3.3,3.3v3.5c0,1.82,1.48,3.3,3.3,3.3h3.5 c1.82,0,3.3-1.48,3.3-3.3v-3.5C13.05,3.93,11.57,2.45,9.75,2.45z M11.75,9.25c0,1.105-0.895,2-2,2h-3.5c-1.104,0-2-0.895-2-2v-3.5 c0-1.104,0.896-2,2-2h3.5c1.105,0,2,0.896,2,2V9.25z';
export const DUMMY_IMAGE = assetUrl('assets/media/avatars/dummyImg.png');
// export const DUMMY_IMAGE_S3 = 'https://media-mct1-1.cdn.whatsapp.net/v/t61.24694-24/473399760_934835608827541_476139211011161795_n.jpg?ccb=11-4&oh=01_Q5AaIKZLYoUhwFvB_IFCL8iFeY7bbtByGK2FL1JEnVV9yYHL&oe=67BC19BC&_nc_sid=5e03e0&_nc_cat=103';
export const DUMMY_IMAGE_S3 = 'https://cloud-recording-meeting.s3.us-east-1.amazonaws.com/meetings/profiles/user-def-dp.jpg';
export const DEFAULT_USER_BACKGROUND_COLOR = '#292d3e';
/*****
//changing any of these value must change in constant.ts
*/
export const LOADER_GIF_LARGE = assetUrl('/assets/images/larger-loader.gif');
export const SMALL_GIF_LARGE = assetUrl('/assets/images/small-loader.gif');
export const SHIMMER_GIF = assetUrl('/assets/images/shimmer.gif');
export const msgWidth = 348;
export const msgHeight = 348;
export const msgMaxLength = 10000;
export const PREVIEW_SM_MAZ_SIZE = 3 * 1024;
export const PREVIEW_LG_MAX_SIZE = 2 * 1024 * 1024;
export const PER_PAGE_MESSAGES = 30;
export const BASE_64_PATTERN = 'data:image/png;base64,';
//ends
export const VOLUME_THRESHOLD = 49;
export const SMALL_DEVICE_WIDTH = 967;

export const CHAT_USER_KEY = environment.appVersion + '-' + environment.CHAT_USER_DATA_KEY;
export const CHAT_USER_INFO_KEY = environment.appVersion + '-' + environment.CHAT_USER_DATA_KEY + '-info';
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
export const IS_CHAT_SERVER_API = new HttpContextToken<boolean>(() => true);
export const MEETING_MODAL_CLASSES = {
  modalDialogClass: 'm-0 mw-100 overflow-hidden',
  ariaLabelledBy: 'agora-audio-video-calling',
  windowClass: 'agora-audio-video-calling'
}

export function LOG_THIS(text = '', data = null) {
  // if (environment['logs']) {
  // }
}

export function GET_CHAT_ENV_URL(): string {
  return localStorage?.getItem('chatUrl')?.trim() ?? environment.chatUrl;
}

export function GET_CHAT_SOCKET_ENV_URL(): string {
  return localStorage?.getItem('wsChatUrl')?.trim() ?? environment.wsChatUrl;
}

export const CHAT_DOMAIN_AND_ENVS = {
  local: {
    localhost: 'http://localhost:4200',
    chatLocalhostWsUrl: localStorage.getItem('cls')?.trim() || 'wss://api-chat.uat.techbar.com/',
  },
  dev: {
    FE: 'https://adminv2-dev.techbar.com',
    wsChatUrl: 'wss://api-chat1.techbar.com/'
  },
  r2: {
    FE: 'https://admin-r2.techbar.com',
    wsChatUrl: 'wss://api-chat-uat.techbar.com/',
  },
  uat: {
    FE: 'https://admin-v2.uat.techbar.com',
    wsChatUrl: 'wss://api-chat.uat.techbar.com/',
  },
  hrms: {
    FE: 'https://hrms.dev.mobilesentrix.com',
    wsChatUrl: 'wss://chat.dev.msrestapi.com/'
  },
  hrmsPreProd: {
    FE: 'https://hrms.preprod.mobilesentrix.com',
    wsChatUrl: 'wss://chat.preprod.msrestapi.com/'
  },
  LDev: {
    FE: 'https://admin18-ldev.4iisolutions.com',
    wsChatUrl: 'wss://api-chat-ldev.4iisolutions.com/'
  },
  angular18: {
    FE: 'https://admin18-dev.techbar.com',
    wsChatUrl: 'wss://dev-chat.4iisolutions.com/'
  },
  qa: {
    FE: 'https://admin18-r2.techbar.com',
    wsChatUrl: 'wss://api-chat-uat.techbar.com/'
  },
  hrms_admin: {
    FE: 'https://admin-hrms.techbar.com',
    wsChatUrl: 'wss://dev-chat.4iisolutions.com/'
  },
  devSa: {
    FE: 'https://dev-sa.4iisolutions.com',
    wsChatUrl: 'wss://dev-chat.4iisolutions.com/'
  }
};

export const PDF_DOMAIN_AND_ENVS = {
  local: {
    apiURL: localStorage.getItem('apiURL')?.trim() || 'https://api-admin-v2.uat.techbar.com/v1',
    pdfSignAppFEUrl: localStorage.getItem('pdfSignAppFEUrl')?.trim() || 'https://pdfsign-r2.techbar.com',
    superAdmin: localStorage.getItem('superAdmin')?.trim() || 'http://localhost:4200'
  },
  dev: {
    pdfSignAppFEUrl: 'https://pdfsign-dev.techbar.com',
    apiURL: 'https://api-adminv2-dev.techbar.com/',
    superAdmin: 'https://adminv2-dev.techbar.com'
  },
  r2: {
    pdfSignAppFEUrl: 'https://pdfsign-r2.techbar.com',
    apiURL: 'https://api-chat-uat.techbar.com/',
    superAdmin: 'https://admin-r2.techbar.com'
  },
  uat: {
    pdfSignAppFEUrl: 'https://pdfsign.uat.techbar.com',
    apiURL: 'https://api-admin-v2.uat.techbar.com/',
    superAdmin: 'https://admin-v2.uat.techbar.com'
  },
  hrms: {
    pdfSignAppFEUrl: 'https://pdfsign.dev.mobilesentrix.com',
    apiURL: 'https://hrms.dev.msrestapi.com/api',
    superAdmin: 'https://hrms.dev.mobilesentrix.com'
  },
  admin_hrms: {
    pdfSignAppFEUrl: 'https://pdfsign-r2.techbar.com',
    apiURL: 'https://api-admin-hrms.techbar.com/',
    superAdmin: 'https://admin-hrms.techbar.com'
  },
  angular18: {
    pdfSignAppFEUrl: 'https://pdfsign-r2.techbar.com',
    apiURL: 'https://api-chat-uat.techbar.com/',
    superAdmin: 'https://admin18-dev.techbar.com'
  }
};

export function GET_FULL_NAME(user: any): string {
  let name = "";
  if (user?.first_name?.length) {
    name += user.first_name;
  }
  if (user?.last_name?.length) {
    name += " " + user.last_name;
  }
  return name;
}

export function IS_VALID_JSON_OBJECT(jsonString: string): boolean {
  try {
    // Remove the surrounding quotes and escape sequences
    const unescapedString = jsonString.replace(/^"|"$/g, '').replace(/\\(["\\])/g, '$1');

    // Now parse the unescaped string into an object
    const parsed = JSON.parse(unescapedString);

    return typeof parsed === 'object' && parsed !== null;
  } catch (error) {
    return false;
  }
}
export const MIN_SECTION_VALUE = 16.5;
export const MAX_SECTION_VALUE = 100;
export const CARD_DEFAULT_TITLE = 'System Default Screen';
export const CARD_DEFAULT_WIDTH = 250;
export const CARD_DEFAULT_MAX_WIDTH = 800;
export const FALL_WITHIN_FULL_RANGE = 98;
export const UPCOMING_CLOCK_REMINDER_TIME = '60';
export const DEFAULT_COLUMNS = 3;
export const MAX_COLUMNS = 12;
export const MIN_COLUMNS_VALUE = 12; //on UI it will be 1 column per section


export enum EmployeeDashBoardViewSectionSEnum {
  DEFAULT = 'default',
  ACTIVE = 'active',
  LEAVE_AND_ABSENTEES = 'leave_and_absentees',
  BREAK_AND_SHORT_BREAK = 'break_and_short_break',
  PUBLIC_HOLIDAYS_AND_WEEKEND = 'public_holidays_and_weekend',
  UPCOMING_CLOCK_OUT = 'upcoming_clock_out',
  UPCOMING_CLOCK_IN = 'upcoming_clock_in',
}

export enum AttendanceType {
  Active = 'active',
  Break = 'break',
  Absents = 'absents',
  Leaves = 'leaves',
  // MissPunchOut = 'miss_punch_out',
  Holiday = 'holiday',
  Weekend = 'weekend',
  UpcomingClockOut = 'upcoming_clock_out',
  UpcomingClockIn = 'upcoming_clock_in',
  ShortBreak = 'ShortBreak',
}

export function DRAG_CARDS(): DragCardItems[] {
  return [
    {
      defaultId: '1',
      title: EmployeeDashBoardViewSectionSEnum.UPCOMING_CLOCK_IN,
      text: 'Upcoming Clock In',
      employees: '',
      columns: '16.6% width',
      temp: false,
      dragCartItem: true,
      width: 16.6,
      cardWidth: 220,
      configs: [
        {
          array_list: AttendanceType.UpcomingClockIn,
          classes: 'bg-cyan-50 border-cyan-300',
          options: {}
        }
      ]
    },
    {
      defaultId: '2',
      title: EmployeeDashBoardViewSectionSEnum.ACTIVE,
      text: 'Active',
      employees: '',
      columns: '32.5% width (with holidays 16.6% only)',
      temp: false,
      dragCartItem: true,
      width: 16.6,
      cardWidth: 220,
      configs: [
        {
          array_list: AttendanceType.Active,
          classes: 'bg-green-500-50 border-green-500-30',
          options: {}
        }]
    },
    {
      defaultId: '3',
      title: EmployeeDashBoardViewSectionSEnum.LEAVE_AND_ABSENTEES,
      text: 'Leave and absentees',
      employees: '',
      columns: '16.6% width',
      temp: false,
      dragCartItem: true,
      width: 16.6,
      cardWidth: 220,
      configs: [
        {
          array_list: AttendanceType.Leaves,
          classes: 'bg-red-500-5 border-red-500-30',
          options: {}
        },
        {
          array_list: AttendanceType.Absents,
          classes: 'bg-red-100 border-red-300',
          options: {}
        }]
    },
    {
      defaultId: '4',
      title: EmployeeDashBoardViewSectionSEnum.BREAK_AND_SHORT_BREAK,
      text: 'Break and short break',
      employees: '',
      columns: '16.6% width',
      temp: false,
      dragCartItem: true,
      width: 16.6,
      cardWidth: 220,
      configs:
        [
          {
            array_list: AttendanceType.Break,
            classes: 'bg-yellow-500-5 border-yellow-500-30',
            options: {}
          }
        ]
    },

    {
      defaultId: '5',
      title: EmployeeDashBoardViewSectionSEnum.UPCOMING_CLOCK_OUT,
      text: 'Upcoming Clock Out',
      employees: '',
      columns: '16.6% width',
      temp: false,
      dragCartItem: true,
      width: 16.6,
      cardWidth: 220,
      configs: [
        {
          array_list: AttendanceType.UpcomingClockOut,
          classes: 'bg-purple-50 border-purple-300',
          options: {}
        }]
    },
    {
      defaultId: '6',
      title: EmployeeDashBoardViewSectionSEnum.PUBLIC_HOLIDAYS_AND_WEEKEND,
      text: 'Public holidays and weekend',
      employees: '',
      columns: '16.6% width',
      temp: false,
      dragCartItem: true,
      width: 16.6,
      cardWidth: 220,
      configs: [
        {
          array_list: AttendanceType.Weekend,
          classes: 'bg-weekend border-weekend',
          options: {}
        }]
    }
  ];
}

export function IS_DOCX_FILE(file: File) {
  const validFileExtensions = /\.(doc|docx)$/i;
  return validFileExtensions.test(file.name)
}
export function IS_PPT_FILE(file: File) {
  const validFileExtensions = /\.(ppt|pptx)$/i;
  return validFileExtensions.test(file.name)
}
export function IS_XLSX_FILE(file: File) {
  const validFileExtensions = /\.(xls|xlsx)$/i;
  return validFileExtensions.test(file.name)
}
export const URL_ARRAY = [
  {
    id: 1,
    name: 'Product Attribute',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/product-attribute.svg'),
    route: 'master-data/ProductAttribute'
  },
  {
    id: 2,
    name: 'Company Types',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/total-employee.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 3,
    name: 'Total Employees',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/total-employee.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 4,
    name: 'Pay Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/pay-type.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 5,
    name: 'Employee Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/employee-type.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 6,
    name: 'Salary Payment Method',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/salary-payment-method.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 7,
    name: 'Allowance Category',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/allowance-category.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 8,
    name: 'Accural Frequancy',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/accural-frequency.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 9,
    name: 'Loan Recovery Method',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/loan-recovery-method.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 10,
    name: 'Payroll Run Fall on Holiday',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/payroll-run-fall.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 11,
    name: 'Docyment Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/document-type.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 12,
    name: 'Marital Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/material-type.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 13,
    name: 'Contract Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/contract-type.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 35,
    name: 'Emp Dependent Relation',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/emp-depentant.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 14,
    name: 'Air Ticket Class Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/air-ticket-class.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 15,
    name: 'Air Ticket Frequancy',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/air-ticket-frequency.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 16,
    name: 'Insurance Class Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/insurance-class-type.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 17,
    name: 'Time Status',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/time-status.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 18,
    name: 'Company Document Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/company-document-type.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 19,
    name: 'Expense Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/expense-type.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 20,
    name: 'Resignation Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/resignation-type.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 21,
    name: 'Seprate Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/separation-type.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 22,
    name: 'Break Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/break-type.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 23,
    name: 'Sepration Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/resignation-type.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 24,
    name: 'Info Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/info-type.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 25,
    name: 'Job Opening Status',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/job-opening-status.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 26,
    name: 'Job Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/job-type.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 27,
    name: 'Work Experience',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/work-experience.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 28,
    name: 'Skillset',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/skill-list.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 29,
    name: 'Industry',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/industry.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 30,
    name: 'Email Template Type',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/email-template-file.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 31,
    name: 'Time Off',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/time-off.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 32,
    name: 'Payroll',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/payroll-run-fall.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 33,
    name: 'Break',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/break.svg'),
    route: 'master-data/ConfigListing'
  },
  {
    id: 34,
    name: 'Asset Categories',
    icon: assetUrl('./assets/media/icons/techbar/master-data-icons/total-employee.svg'),
    route: 'master-data/ConfigListing'
  },

]

//do not remove this
export const PDFSignAppRoutes = {
  request: {
    id: 1,
    path: 'pdf/request/sign'
  },
  sign: {
    id: 2,
    path: 'pdf/sign/new'
  },
  signMySelf: {
    id: 3,
    path: 'pdf/sign/myself'
  },
  view: {
    id: 4,
    path: 'pdf/view/mode'
  },
};

//do not remove this
export const PDFModes = {
  request: "request",
  sign: "sign",
  signMySelf: "signMySelf",
  view: "view",
};

export const IFrame = {
  PDF_SIGN: 'pdf_sign_app',
  SUPER_ADMIN: 'super_admin_app',
}

export const AUDIO_SOURCE = {
  system: 'system',
  voice_recorded: 'voice_recorded',
}

export function RESET_PAGINATOR(paginator: any = null, per_page = 10): any {
  if (paginator?.per_page) {
    per_page = paginator.per_page;
  }
  return {
    current_page: 1,
    previous_page: 0,
    per_page: per_page
  };
}

export interface ChatRoom {
  roomId: number;
  userId: number;
  name: string;
  type: string;
  ts: string | Date;
  avatar: string;
  uids: number[];
  usernames: string[];
  lastMessage: any;
  pinMessages: any[];
  members: any[];
  chat_type: string;
  status: string;
  unreadMessages: number;
  typing: boolean;
  meeting?: boolean;
  loadingStatus?: boolean;
  rechecking?: boolean;
  [key: string]: any;
}

export function GET_CHANNEL_NAME(room: ChatRoom): string {
  try {
    if (room?.name && room?.roomId) {
      const channelName = room?.name?.replace(/\s+/g, "") + room?.roomId;
      return channelName?.toLowerCase();
    }
    return "";
  } catch (error) {
    return "";
  }
}

export const success = (status: number) => {
  return status == 200;
};

export const _success = (res: any) => {
  return res?.data == 'SUCCESS';
};

export const RES_OK = (res: any) => {
  return res?.statusCode == 200 || res?.statusCode == 201 || res?.success == true || res?.data == 'SUCCESS';
};

export const isImageOrVideo = (item: any) => {
  return (item?.image_url || item?.video_url) ? true : false;
};

export const isImage = (item: any) => {
  return item?.image_url ? true : false;
};

export const isVideo = (item: any) => {
  return item?.video_url ? true : false;
};


export enum CONSOLE {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
  LOG = 4
}

//log for me
export function LOGGER(message: string, data: any, type: CONSOLE = CONSOLE.LOG) {
  try {

    let isLogger = localStorage.getItem('Logger')?.trim();
    if (!isLogger?.length) {
      return;
    }
    switch (type) {
      case CONSOLE.ERROR:
        console.error(message, data);
        break;
      case CONSOLE.INFO:
        console.info(message, data);
        break;
      case CONSOLE.WARN:
        console.warn(message, data);
        break;
      case CONSOLE.LOG:
        console.log(message, data);
        break;
      default:
        console.log('default: ' + message, data);
        break;
    }
  } catch (error) {
    console.log('LOGGER error', error);
  }
}

/** 
 * @description
 * @argument array of objects
 * @property in the object based on which duplicates will be removed
 * remove duplicate data based on the params provided like id*/
export function MAKE_ARRAY_UNIQUE(arr: any[], property: string, property2?: any) {
  try {
    if (!Array.isArray(arr) || typeof property !== "string") {
      return [];
    }
    //filter signature: (object, index, thisArray)
    const uniqueArray = arr?.filter((obj, index, self) => {
      if (obj && typeof obj === "object") {
        const firstIndex = self?.findIndex(data => data && (data[property] == obj[property] && !property2 || (property2 && data[property] == obj[property] && data[property2] == obj[property2])));
        if (index !== firstIndex) {
        }
        return index === firstIndex;
      } else {
        return false;
      }
    });

    return uniqueArray;
  } catch (error) {
    console.error("An error occurred in MAKE_ARRAY_UNIQUE:", error);
    return [];
  }
}

export function REMOVE_TEXT_AFTER_AT(value: string): string {
  if (!value) return value;
  const atIndex = value?.indexOf('_');
  return atIndex !== -1 ? value.substring(0, atIndex) : value;
}

// Remove duplicate data based on the provided properties (like id, name, etc.)
// export function MAKE_ARRAY_UNIQUE(arr: any[], properties: string[]) {
//   try {
//     if (!Array.isArray(arr) || !Array.isArray(properties) || properties.some(prop => typeof prop !== "string")) {
//       return [];
//     }

//     // Filter signature: (object, index, thisArray)
//     const uniqueArray = arr?.filter((obj, index, self) => {
//       if (obj && typeof obj === "object") {
//         const firstIndex = self?.findIndex(data => data && properties.every(prop => data[prop] === obj[prop]));
//         if (index !== firstIndex) {
//         }
//         return index === firstIndex;
//       } else {
//         return false;
//       }
//     });

//     return uniqueArray;
//   } catch (error) {
//     console.error("An error occurred in MAKE_ARRAY_UNIQUE:", error);
//     return [];
//   }
// }



export function GET_VIDEO_RATIO_FROM_FILE(file: File): Promise<number> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event: any) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.onloadedmetadata = () => {
        const ratio = video.videoWidth / video.videoHeight;
        resolve(ratio);
      };
      video.onerror = (error) => {
        reject(error);
      };
      video.src = event.target.result;
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
}


export function GET_VIDEO_RATIO_FROM_URL(videoUrl: string): Promise<number> {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      const ratio = video.videoWidth / video.videoHeight;
      resolve(ratio);
    };
    video.onerror = (error) => {
      reject(error);
    };
    video.src = videoUrl;
  });
}

export function GET_IMAGE_RATIO_FROM_FILE(file: File): Promise<number> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event: any) => {
      const img = new Image();
      img.onload = () => {
        const ratio = img.width / img.height;
        resolve(ratio);
      };
      img.src = event.target.result;
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsDataURL(file);
  });
}

export function GET_IMAGE_RATIO_FROM_URL(imageUrl: string): Promise<number> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const ratio = img.width / img.height;
      resolve(ratio);
    };
    img.onerror = (error) => {
      reject(error);
    };
    img.src = imageUrl;
  });
}

export function GET_VIDEO_DIMENSIONS_FROM_URL(videoUrl: string): Promise<{ width: number, height: number }> {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      const dimensions = {
        width: video.videoWidth,
        height: video.videoHeight
      };
      resolve(dimensions);
    };
    video.onerror = (error) => {
      reject(error);
    };
    video.src = videoUrl;
  });
}

export function GET_IMAGE_DIMENSIONS_FROM_URL(imageUrl: string): Promise<{ width: number, height: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const dimensions = {
        width: img.width,
        height: img.height
      };
      resolve(dimensions);
    };
    img.onerror = (error) => {
      reject(error);
    };
    img.src = imageUrl;
  });
}

//find video dimensions FROM FILE
export function GET_VIDEO_DIMENSION_FROM_FILE(file: File): Promise<{ width: number, height: number }> {
  return new Promise((resolve, reject) => {
    const video: HTMLVideoElement = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      resolve({ width: video.videoWidth, height: video.videoHeight });
    };
    video.onerror = (error) => {
      reject(error);
    };
    video.src = URL.createObjectURL(file);
  });
}

//find image dimensions FROM FILE
export function GET_IMAGE_DIMENSION_FROM_FILE(file: File): Promise<{ width: number, height: number }> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event: any) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.src = event.target.result;
    };

    reader.readAsDataURL(file);
  });
}

//find image dimensions FROM base64
export function GET_IMAGE_DIMENSION_FROM_BASE64(base64Image: string): Promise<{ width: number, height: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64Image;
    img.onload = () => {
      const width = img.width;
      const height = img.height;
      resolve({ width, height });
    };

    img.onerror = (err) => {
      reject(err);
    };
  });
}

export function CALCULATE_ASPECT_RATIO(width: number, height: number): Promise<{ aspectWidth: number, aspectHeight: number }> {

  return new Promise((resolve, reject) => {

    function gcd(a: number, b: number): number {
      return b === 0 ? a : gcd(b, a % b);
    }
    const gcdData = gcd(width, height);
    const aspectWidth = width / gcdData;
    const aspectHeight = height / gcdData;
    resolve({ aspectWidth, aspectHeight });
  });
}

export const channel_users: any[] = [];

export const consoleLog = {
  "success": `background-color: green;color: white;font-style: italic;border: 1px dashed blueviolet;font-size: 2em;`,
  "error": `background-color: red;color: black;font-style: italic;border: 1px dashed blueviolet;font-size: 2em;`,
  "warning": `background-color: yellow;color: black;font-style: italic;border: 1px dashed blueviolet;font-size: 2em;`,
  "normal": `background-color: black;color: white;font-style: normal;border: 1px solid green;font-size: 2em;`
}

export const MIME_TYPES: Record<CreateDocType, string> = {
  'google-docs': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'google-sheets': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'google-slides': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'excel': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'powerpoint': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
};


export const TOASTER_OPTIONS: Partial<ToasterOptions> = {
  type: 'black'
}

/**
 * @description replace _ with spaces and capitalize each word 
 * @param item - The drive item for which to get the formatted type
 */
export function GET_TYPE_DOC(item: DriveItem): string {
  return (item.activity_type ?? item.type ?? (item.isFile ? 'File' : 'Folder'))?.replaceAll('_', ' ')?.replace(/\b\w/g, l => l.toUpperCase()) ?? '';
}

/**
 * @description replace _ with spaces and capitalize each word
 * @param type - The type string to format
 * @returns The formatted type string
 */
export function GET_STRING_FORMATTED(type: string): string {
  return type?.replaceAll('_', ' ')?.replace(/\b\w/g, l => l.toUpperCase()) ?? '';
}

/**
 * @description get google auth url with continue route 
 * @param continueRoute - The route to continue to after authentication
 * @returns The Google authentication URL with the continue route
 */

export function GET_GOOGLE_AUTH_URL(continueRoute: string): string {
  return `https://accounts.google.com/ServiceLogin?passive=true&continue=${encodeURIComponent(continueRoute)}`
}

export function GET_V2_BASE(): string {
  return environment.restV2URI.replace(/\/$/, '') + '/api/v2';
}
